<div class="box1 point-container">
  <div class="row g-0">
    <div class="col text1">{{ "common.myPoints" | translate }}</div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-lg-5 mt-3">
      <div class="row d-flex gap-10">
        <div class="col-3 col-md-2">
          <img class="img--wallet" src="assets/img/wallet-1.png" />
        </div>
        <div
          class="col-8 available--points"
          [class]="lang.isRTL ? 'rtl-available--points' : ''"
        >
          <div class="text2">
            <app-spinner *ngIf="loading"></app-spinner>
            {{ flexDollarsAvailable | number }}
          </div>
          <div class="point--details">
            <!-- <img class="ms-2 img--reload" src="assets/img/reload.png" width="10.5px" height="10.5px"
            /> -->
            &nbsp;&nbsp;
            <div class="text__desc-detail">
              {{ "common.pointsAvailableForRedemption" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-lg-7 mt-3">
      <div class="row g-3">
        <div
          class="col-12 box--img-wrapper"
          [ngClass]="!!expiryPoint ? 'col-md-4' : 'col-md-6'"
          (click)="updateTransactions('earned', 'all')"
        >
          <div class="d-flex flex-column box__detail2 px-2 py-3">
            <div class="text__point-detail">
              {{ flexDollarsEarned | number }}
            </div>
            <div class="text__desc-detail mt-2">
              {{ "common.totalPointsEarned" | translate }}
            </div>
          </div>
        </div>
        <div
          class="col-12 box--img-wrapper"
          [ngClass]="!!expiryPoint ? 'col-md-4' : 'col-md-6'"
          (click)="updateTransactions('redeemed', 'all')"
        >
          <div class="d-flex flex-column box__detail2 px-2 py-3">
            <div class="text__point-detail">
              {{ flexDollarsRedeemed | number }}
            </div>
            <div class="text__desc-detail mt-2">
              {{ "common.totalPointsRedeemed" | translate }}
            </div>
          </div>
        </div>
        <div
          *ngIf="!!expiryPoint"
          class="col-12 col-md-4 box--img-wrapper"
          (click)="updateTransactions('expiring', 'all')"
        >
          <div class="d-flex flex-column box__detail3 p-3">
            <div class="text__point-detail">
              {{ pointsExpiringThisMonth.points | number }}
            </div>
            <div class="text__desc-detail text__expiry-points mt-2">
              {{
                "common.totalPointsExpiring"
                  | translate
                    : {
                        year: showYearlyExpiringPoints
                          ? (pointsExpiringThisMonth.expiry_date | date: "yyyy")
                          : (pointsExpiringThisMonth.expiry_date
                            | date: "dd MMM yyyy")
                      }
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
